import { useQuery, useQueryClient } from '@tanstack/react-query';

import { REACT_QUERY_KEYS } from 'constants/reactQueryKeys';

import { getAIManagerSummaryPoints } from 'services/performanceReview';

export const useManagerSummary = ({
  reviewId,
  empId,
  questionId,
  goalId,
  goalText,
  goalProgressLevel,
  competencyText,
  competencyDescription,
  competencyId,
}) =>
  useQuery(
    [REACT_QUERY_KEYS.ManagerAISummary.ManagerAISummary, reviewId, empId, questionId, goalId, competencyId],
    () =>
      getAIManagerSummaryPoints({
        reviewId,
        empId,
        questionId,
        goalId,
        goalText,
        goalProgressLevel,
        competencyText,
        competencyDescription,
        competencyId,
      }).then((res) => res.entity),
    { enabled: !!reviewId && !!empId && !!questionId, staleTime: Infinity }
  );

export const useInvalidateManagerSummary = () => {
  const queryClient = useQueryClient();
  return () =>
    queryClient.invalidateQueries({
      queryKey: [REACT_QUERY_KEYS.ManagerAISummary.ManagerAISummary],
    });
};
